
import { useState } from 'react';

export default function Testimonials() {
  const [currentIndex, setCurrentIndex] = useState(0);

  const testimonials = [
    {
      quote: "Tadashi Consulting transformed our dated apartment into a stunning modern home. Their attention to detail and commitment to quality is unmatched. Every deadline was met, and the final result exceeded our expectations.",
      name: "Sarah Mitchell",
      project: "Penthouse Renovation",
      rating: 5,
      image: "https://public.readdy.ai/ai/img_res/2fcf92745f20ef1640fa506b78c80d40.jpg"
    },
    {
      quote: "As a property developer, I’ve worked with many contractors. Tadashi Consulting stands out for their professionalism, transparency, and exceptional craftsmanship. They’re now my go-to partner for all luxury renovations.",
      name: "David Chen",
      project: "Commercial Development",
      rating: 5,
      image: "https://readdy.ai/api/search-image?query=professional%20portrait%20of%20asian%20businessman%20in%20his%2050s%20confident%20demeanor%20suit%20and%20tie%20natural%20lighting%20high%20quality%20headshot%20sophisticated%20appearance%20friendly%20smile&width=200&height=200&seq=client-david-001&orientation=squarish"
    },
    {
      quote: "The team at Tadashi Consulting brought our heritage home into the 21st century while respecting its character. Their expertise in structural work and high-end finishes is truly impressive. Highly recommended.",
      name: "Emma Thompson",
      project: "Heritage Home Restoration",
      rating: 5,
      image: "https://readdy.ai/api/search-image?query=professional%20portrait%20of%20elegant%20woman%20in%20her%2050s%20warm%20smile%20casual%20elegant%20attire%20natural%20lighting%20high%20quality%20headshot%20sophisticated%20appearance%20genuine%20expression&width=200&height=200&seq=client-emma-001&orientation=squarish"
    }
  ];

  const handlePrev = () => {
    setCurrentIndex((prev) => (prev === 0 ? testimonials.length - 1 : prev - 1));
  };

  const handleNext = () => {
    setCurrentIndex((prev) => (prev === testimonials.length - 1 ? 0 : prev + 1));
  };

  // Safety: Guard against empty testimonial list
  if (!testimonials.length) {
    return null;
  }

  const { quote, name, project, rating, image } = testimonials[currentIndex];

  return (
    <section className="py-16 md:py-24 lg:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-10 lg:gap-16 items-center">
          {/* Left Content Zone */}
          <div className="lg:col-span-2 space-y-8 md:space-y-12">
            <div className="space-y-4 md:space-y-6">
              <p className="text-xs font-semibold tracking-widest text-[#D4AF37] uppercase">
                Client Testimonials
              </p>
              <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-[#2A2A2A] leading-tight">
                Trusted by Homeowners<br className="hidden sm:block" />
                &amp; Property Developers
              </h2>
            </div>

            {/* Featured Review Card */}
            <div className="bg-white rounded-2xl md:rounded-3xl shadow-2xl p-6 sm:p-8 md:p-12 space-y-6 md:space-y-8">
              {/* Quote */}
              <div className="relative">
                <i className="ri-double-quotes-l text-3xl md:text-4xl text-[#D4AF37] absolute -top-2 md:-top-4 -left-1 md:-left-2"></i>
                <p className="text-lg sm:text-xl md:text-2xl font-serif text-[#2A2A2A] leading-relaxed pl-6 md:pl-8">
                  {quote}
                </p>
                <i className="ri-double-quotes-r text-3xl md:text-4xl text-[#D4AF37] absolute -bottom-2 md:-bottom-4 -right-1 md:-right-2"></i>
              </div>

              {/* Rating */}
              <div className="flex items-center gap-1.5 md:gap-2">
                {[...Array(rating)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-lg md:text-xl text-[#D4AF37]"></i>
                ))}
              </div>

              {/* Client Info */}
              <div className="flex items-center gap-4 md:gap-6">
                <div className="w-12 h-12 md:w-16 md:h-16 rounded-full overflow-hidden border-2 border-[#D4AF37] flex-shrink-0">
                  <img
                    src={image}
                    alt={name}
                    className="w-full h-full object-cover"
                    onError={(e) => {
                      e.currentTarget.src =
                        "https://via.placeholder.com/200?text=No+Image";
                    }}
                  />
                </div>
                <div>
                  <p className="text-base md:text-lg font-bold text-[#2A2A2A]">{name}</p>
                  <p className="text-xs md:text-sm text-gray-600">{project}</p>
                </div>
              </div>
            </div>

            {/* Navigation Controls */}
            <div className="flex items-center gap-4">
              <button
                onClick={handlePrev}
                className="w-10 h-10 md:w-12 md:h-12 rounded-full border-2 border-[#D4AF37] text-[#D4AF37] hover:bg-[#D4AF37] hover:text-white transition-all flex items-center justify-center cursor-pointer"
                aria-label="Previous testimonial"
              >
                <i className="ri-arrow-left-line text-lg md:text-xl"></i>
              </button>
              <button
                onClick={handleNext}
                className="w-10 h-10 md:w-12 md:h-12 rounded-full bg-[#D4AF37] text-white hover:bg-[#B8941F] transition-all flex items-center justify-center cursor-pointer"
                aria-label="Next testimonial"
              >
                <i className="ri-arrow-right-line text-lg md:text-xl"></i>
              </button>
            </div>
          </div>

          {/* Right Visual Zone - Hidden on mobile, shown on lg */}
          <div className="hidden lg:block h-full">
            <div className="rounded-3xl overflow-hidden shadow-2xl h-full min-h-[600px]">
              <img
                src="https://readdy.ai/api/search-image?query=elegant%20luxury%20residential%20property%20exterior%20modern%20architecture%20beautiful%20landscaping%20high%20end%20home%20sophisticated%20design%20premium%20construction%20quality%20contemporary%20building%20refined%20finishes%20impressive%20curb%20appeal&width=600&height=900&seq=testimonial-property-001&orientation=portrait"
                alt="Client Property"
                className="w-full h-full object-cover"
                onError={(e) => {
                  e.currentTarget.src =
                    "https://via.placeholder.com/600x900?text=No+Image";
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
